import { useSelector } from 'react-redux';
import AdvancedSearchActions from '../../../components/core/advanced-search/AdvancedSearchActions';
import AdvancedSearchField from '../../../components/core/advanced-search/AdvancedSearchField';
import AdvancedSearchHeader from '../../../components/core/advanced-search/AdvancedSearchHeader';
import AdvancedSearchSection from '../../../components/core/advanced-search/AdvancedSearchSection';
import SimpleSearch from '../../../components/core/SimpleSearch';
import { useSimpleSearch } from '../../../hooks/useSimpleSearch.hook';
import { currentUserSelector } from '../../../selectors/auth.selectors';
import { resourceStateSelector } from '../../../selectors/resources.selectors';

const _filterField = (field, section, filters, user) =>
  field.section === section.name && (!field.getIsVisible || (field.getIsVisible && field.getIsVisible(filters, user)));

const AdvancedSearch = ({
  className = '',
  resource,
  dataResource,
  simpleSearchKey = 'query',
  dependencies,
  onOpen,
  isOpen,
  activeFiltersCount = 0,
  onSearch,
  onClear,
  onInput
}) => {
  const resourceData = useSelector((state) => resourceStateSelector(state, { resource }));
  const user = useSelector(currentUserSelector);
  const filters = resourceData?.filters ?? {};
  const simpleSearch = useSimpleSearch(dataResource, simpleSearchKey);

  const handleOpenAdvancedSearch = () => {
    simpleSearch.onChange('');
    onOpen();
  };

  return (
    <div className={`spo-o-advanced-search ${className} ${isOpen ? 'is-open' : ''}`}>
      <div className="spo-o-advanced-search__header-wrapper">
        {!isOpen && <SimpleSearch className="u-margin-bottom-xs u-margin-top-xs u-margin-right" {...simpleSearch} />}
        <AdvancedSearchHeader
          title={resource?.title}
          activeFiltersCount={activeFiltersCount}
          isOpen={isOpen}
          onOpen={handleOpenAdvancedSearch}
        />
      </div>
      <div className="spo-o-advanced-search__content">
        {resource?.sections?.map((section) => (
          <AdvancedSearchSection key={section.name} {...section}>
            {resource?.fields
              ?.filter((field) => _filterField(field, section, filters, user))
              ?.map((field) => (
                <AdvancedSearchField
                  key={field.name}
                  {...field}
                  value={filters?.[field.name]}
                  onChange={onInput}
                  onEnter={onSearch}
                  options={field.dependency ? dependencies?.[field?.dependency]?.options : []}
                  isLoadingDependency={dependencies?.[field?.dependency]?.isLoading ?? false}
                  loadDependencyError={dependencies?.[field?.dependency]?.loadError || ''}
                />
              ))}
          </AdvancedSearchSection>
        ))}
        <AdvancedSearchActions className="u-margin-top" onClear={onClear} onSearch={onSearch} />
      </div>
    </div>
  );
};

export default AdvancedSearch;
